/* unplugin-vue-components disabled */import script from "./IndexPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndexPage.vue?vue&type=script&setup=true&lang=ts"

import "./IndexPage.vue?vue&type=style&index=0&id=c2f736d0&lang=css"

const __exports__ = script;

export default __exports__